import * as React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import * as Api from '../api/api';
import { ApplicationState } from '../store';
import * as Colors from "../styles/colors";
import * as DocumentStore from "../store/Document";

import DescriptionIcon from '@material-ui/icons/Description';

import InfoIcon from '@material-ui/icons/Info';
import PlayArrowIcon from "@material-ui/icons/PlayArrow";


type HelpCenterProps = HelpCenterOwnProps
    & DocumentStore.DocumentState
    & typeof DocumentStore.actionCreators;

interface HelpCenterOwnProps {
    carriers: { [id: number]: Api.CarrierModel };
}

const containerStyle = {
    fontFamily: "Calibri",
    margin: "20px"
};

const iconStyle = {
    color: Colors.baseColors.lightBlue,
    verticalAlign: "bottom"
} as React.CSSProperties;


const linkStyle = {
    cursor: "pointer",
    color: Colors.baseColors.lightBlue,
    paddingLeft: "15px"

} as React.CSSProperties;

class HelpCenter extends React.Component<HelpCenterProps, {}> {

    onPropsUpdate(props: HelpCenterProps) {
        if (new Date().getTime() - this.props.requestTime > 1000 * 60 * 10) {
            this.props.requestHelpCenterDocuments(new Date().getTime());
        }
    }

    componentWillMount() {
        this.onPropsUpdate(this.props);
    }

    componentWillReceiveProps(nextProps: HelpCenterProps) {
        this.onPropsUpdate(nextProps);
    }
    public render() {

        var videos = this.props.helpCenterDocuments.filter((doc) => doc.contentType == "Video");
        var files = this.props.helpCenterDocuments.filter((doc) => doc.contentType == "Document");
        console.log(videos);
        return (
            <div style={containerStyle}>
                <h1>  <InfoIcon style={{ color: Colors.baseColors.lightBlue }} />Help center</h1>
                <div style={{
                    marginRight: "12px",
                    position: "relative",
                    top: "2px",
                }} />
                <div>
                    <h3>Written guides</h3>
                    {files.map((file) => (
                        <div >
                            <a style={{ ...linkStyle }} onClick={(e) => {
                                if (!this.props.downloadStates[file.helpCenterItemId]
                                    || !this.props.downloadStates[file.helpCenterItemId].isLoading) {
                                    this.props.downloadHelpCenterDocument(new Date().getTime(), file.helpCenterItemId);
                                }
                            }}><DescriptionIcon style={iconStyle} />{file.name}</a><span> - {file.description}</span>
                        </div>
                    ))}


                    <h3>Video tutorials</h3>
                    {videos.map((video) => (
                        <div >
                            <a style={linkStyle} target="_blank" href={video.link}
                            ><PlayArrowIcon style={iconStyle} />{video.name}</a> - {video.description}
                        </div>
                    ))


                    }



                </div>
            </div>
        );
    }
}



export default connect((state: ApplicationState) => ({
    ...state.document,

    carriers: state.seed.carriers,

}),
    DocumentStore.actionCreators)(HelpCenter) as any